import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import "./sidebar.css";
import ilogo from "assets/img/Clogo1.png";
// import logo from "assets/images/pro.png";
import CameraLogo from "assets/img/camera.jpeg";
import group from "assets/img/camera.jpeg";
import menicon from "assets/img/menicon.jpg";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getCurrentUserRoleService } from "services/api-service"; // ✅ Import service
const logo = "https://camsecai.com/2camsecai-logo.png";

function Sidebar({ color, image, routes, setIsCollapsed, isCollapsed }) {
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down("md"));
  const sm_matches = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  // ✅ NEW: Store user role and filtered routes
  const [userRole, setUserRole] = useState(null);
  const [filteredRoutes, setFilteredRoutes] = useState(routes);
  const [loadingRole, setLoadingRole] = useState(true);
  const [settingsOpen, setSettingsOpen] = useState(false);

  // ✅ Fetch user role on component mount
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await getCurrentUserRoleService();
        console.log("👤 User Role Response:", response.data);
        setUserRole(response.data.role_type);
      } catch (error) {
        console.error("❌ Error fetching user role:", error);
        setUserRole(null);
      } finally {
        setLoadingRole(false);
      }
    };

    fetchUserRole();
  }, []);

  // ✅ Filter routes based on user role
  useEffect(() => {
    if (loadingRole) return;

    // Routes that ONLY IT_ADMIN can see
    const adminOnlyMenuItems = [
      "Camera Setting",
      "Area Selection",
      "Holiday Manager",
      "🔐 Role Management",
      " Count Analytics",
      "Settings",  // ← Moved here
    ];

    const completelyHiddenMenuItems = [
      "Session",
      "Events",
      // ✅ Settings removed from here
    ];

    // If user is IT_ADMIN, show all routes EXCEPT completely hidden ones
    if (userRole === "IT_ADMIN") {
      const filtered = routes.filter(
  (route) => !completelyHiddenMenuItems.includes(route.name)
);
      setFilteredRoutes(filtered);
      console.log("✅ IT_ADMIN - Showing all except hidden items");
    } else {
      // Non-admin: hide admin-only AND completely hidden items
      const filtered = routes.filter(
        (route) =>
          !adminOnlyMenuItems.includes(route.name) &&
          !completelyHiddenMenuItems.includes(route.name)
      );
      setFilteredRoutes(filtered);
      console.log("🔒 Non-admin - Filtered routes for non-admin user:", filtered);
    }
  }, [userRole, routes, loadingRole]);

  // Determine active route
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  // ✅ Show loading state while fetching role
  if (loadingRole) {
    return (
      <div
        className={`sidebar ${isCollapsed ? "hide_sidebar" : ""}`}
        style={{ opacity: 0.6 }}
      >
        <div className="sidebar-wrapper">
          <p style={{ padding: "20px", textAlign: "center", color: "#999" }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {md_matches ? (
        <div
          onMouseEnter={() => setIsCollapsed(false)}
          onMouseLeave={() => setIsCollapsed(true)}
          className={`sidebar`}
          data-image={image}
          data-color={color}
          style={{ transition: "0.2s", overflow: "hidden" }}
        >
          <div
            className="sidebar-background"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="sidebar-wrapper">
            {/* Logo */}
            <div
              style={{ marginTop: "30px", marginBottom: "30px" }}
              className="logo d-flex align-items-center justify-content-start"
            >
              <div
                className="logo-img"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <img src={ilogo} alt="..." />
                {!isCollapsed && (
                  <img
                    style={{ width: "130px", marginTop: "5px" }}
                    src={logo}
                    alt="Full Logo"
                  />
                )}
              </div>
            </div>

            {/* ✅ Show user role badge if not IT_ADMIN */}
            {userRole && userRole !== "IT_ADMIN" && (
              <div
                style={{
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #2196f3",
                  borderRadius: "4px",
                  padding: "8px",
                  marginBottom: "15px",
                  fontSize: "12px",
                  color: "#1565c0",
                  textAlign: "center",
                  display: isCollapsed ? "none" : "block",
                }}
              >
                <strong>Role:</strong> {userRole}
              </div>
            )}

            {/* Navigation */}
            <Nav>
              {filteredRoutes.map((prop, key) => {
                if (!prop.redirect)
                  return (
                    <li
                      key={key}
                      className={
                        prop.dashboard
                          ? "active active-pro"
                          : activeRoute(prop.layout + prop.path)
                      }
                      style={{
                        width: isCollapsed ? "83px" : "100%",
                        height: "50px",
                      }}
                    >
                      {prop.name === "Hide/Show" ? (
                        <div>
                          {/* Hide/Show toggle removed */}
                        </div>
                      ) : (
                        <NavLink
                          style={{ height: "50px" }}
                          to={
                            prop?.name === "Sign Out"
                              ? "/"
                              : prop.layout + prop.path
                          }
                          className="nav-link"
                          activeClassName="active"
                        >
                          {/* Holiday Management Icon */}
                          {prop?.name === "Holiday Manager" ? (
                            <span
                              style={{
                                fontSize: "20px",
                                marginRight: "10px",
                                marginLeft: "-5px",
                              }}
                            >
                              🗓️
                            </span>
                          ) : prop?.name === "Camera Setting" ? (
                            <img
                              style={{ width: "32px", marginRight: "10px" }}
                              src={CameraLogo}
                            />
                          ) : (
                            <i
                              style={{ color: "black", marginLeft: "-5px" }}
                              className={prop.icon}
                            />
                          )}

                          {prop?.name === "Area Selection" ? (
                            <img
                              style={{ width: "32px", marginRight: "10px" }}
                              src={group}
                            />
                          ) : (
                            <i style={{ color: "black", marginLeft: "-5px" }} />
                          )}

                          <p style={{ color: "black" }}>
                            {isCollapsed ? "" : prop.name}
                          </p>
                        </NavLink>
                      )}
                    </li>
                  );
                return null;
              })}
            </Nav>
          </div>
        </div>
      ) : (
        <div
          onMouseEnter={() => setIsCollapsed(false)}
          onMouseLeave={() => setIsCollapsed(true)}
          className={`sidebar ${isCollapsed ? "hide_sidebar" : ""}`}
          data-image={image}
          data-color={color}
          style={{ transition: "0.2s", overflow: "hidden" }}
        >
          <div
            className="sidebar-background"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="sidebar-wrapper">
            {/* Logo */}
            <div
              style={{ marginTop: "30px", marginBottom: "30px" }}
              className="logo d-flex align-items-center justify-content-start"
            >
              <div
                className="logo-img"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <img src={ilogo} alt="..." />
                {!isCollapsed && (
                  <img
                    style={{ width: "130px", marginTop: "5px" }}
                    src={logo}
                    alt="Full Logo"
                  />
                )}
              </div>
            </div>

            {/* ✅ Show user role badge if not IT_ADMIN */}
            {userRole && userRole !== "IT_ADMIN" && (
              <div
                style={{
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #2196f3",
                  borderRadius: "4px",
                  padding: "8px",
                  marginBottom: "15px",
                  fontSize: "12px",
                  color: "#1565c0",
                  textAlign: "center",
                  display: isCollapsed ? "none" : "block",
                }}
              >
                <strong>Role:</strong> {userRole}
              </div>
            )}

            {/* Navigation */}
            <Nav>
              {filteredRoutes.map((prop, key) => {
                if (!prop.redirect)
                  return (
                    <li
                      key={key}
                      className={
                        prop.dashboard
                          ? "active active-pro"
                          : activeRoute(prop.layout + prop.path)
                      }
                      style={{
                        width: isCollapsed ? "83px" : "100%",
                        height: "50px",
                      }}
                    >
                      {prop.name === "Hide/Show" ? (
                        <div>
                          {/* Hide/Show toggle removed */}
                        </div>
                      ) : (
                        <NavLink
                          style={{ height: "50px" }}
                          to={
                            prop?.name === "Sign Out"
                              ? "/"
                              : prop.layout + prop.path
                          }
                          className="nav-link"
                          activeClassName="active"
                        >
                          {/* Holiday Management Icon */}
                          {prop?.name === "Holiday Manager" ? (
                            <span
                              style={{
                                fontSize: "20px",
                                marginRight: "10px",
                                marginLeft: "-5px",
                              }}
                            >
                              🗓️
                            </span>
                          ) : prop?.name === "Camera Setting" ? (
                            <img
                              style={{ width: "32px", marginRight: "10px" }}
                              src={CameraLogo}
                            />
                          ) : (
                            <i
                              style={{ color: "black", marginLeft: "-5px" }}
                              className={prop.icon}
                            />
                          )}

                          {prop?.name === "Area Selection" ? (
                            <img
                              style={{ width: "32px", marginRight: "10px" }}
                              src={group}
                            />
                          ) : (
                            <i style={{ color: "black", marginLeft: "-5px" }} />
                          )}

                          <p style={{ color: "black" }}>
                            {isCollapsed ? "" : prop.name}
                          </p>
                        </NavLink>
                      )}
                    </li>
                  );
                return null;
              })}
            </Nav>
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;
